import {createTheme, responsiveFontSizes} from '@mui/material/styles';


let theme = createTheme({
    palette: {
        primary: {
            main: '#1b391b'
        },
        secondary: {
            main: '#43122b'
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
    components: {
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#1b391b',
                    color: 'white',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '1.25rem',
                    padding: '12px 60px',
                },
            },
        },
        MuiButton: {
            defaultProps: {
                size: 'large',
            }, styleOverrides: {
                root: {
                    textTransform: 'none',
                    '&.MuiButton-outlinedSecondary': {
                        color: 'white',
                    },
                    '&.MuiButton-containedSecondary': {
                        color: 'white',
                    },
                }
            }
        },
        MuiIconButton: {
            defaultProps: {
                size: 'large',
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: '2rem',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    position: 'sticky',
                },
            },
        },
    },
});

theme = createTheme(theme, responsiveFontSizes(theme));

export default theme;